/* Sons LP — behaviour for sons-lp-* sections. Safe to include more than once. */
(function () {
  if (window.__sonsLP) return;
  window.__sonsLP = true;

  var ACTIVE = 'is-active';

  /* ---------- carousels: [data-sl-slider] > [data-sl-track], [data-sl-prev|next], [data-sl-dots] ---------- */
  function step(track) {
    var a = track.children[0], b = track.children[1];
    if (!a) return track.clientWidth || 1;
    return b ? b.offsetLeft - a.offsetLeft : a.offsetWidth;
  }
  function go(track, left) {
    var max = track.scrollWidth - track.clientWidth;
    track.scrollTo({ left: Math.max(0, Math.min(left, max)), behavior: 'smooth' });
  }
  function pages(track) {
    var max = track.scrollWidth - track.clientWidth, p = step(track) || 1;
    return max > 2 ? Math.round(max / p) + 1 : 1;
  }
  function current(track) {
    var p = step(track) || 1;
    return Math.min(Math.round(track.scrollLeft / p), pages(track) - 1);
  }
  function syncSlider(root) {
    var track = root.querySelector('[data-sl-track]');
    if (!track) return;
    var n = pages(track), i = current(track);
    var dots = root.querySelector('[data-sl-dots]');
    if (dots) {
      if (dots.children.length !== n) {
        dots.innerHTML = '';
        for (var k = 0; k < n; k++) {
          var d = document.createElement('button');
          d.type = 'button'; d.className = 'sl-dot'; d.setAttribute('aria-label', 'Go to slide ' + (k + 1));
          d.setAttribute('data-sl-dot', k);
          dots.appendChild(d);
        }
      }
      [].forEach.call(dots.children, function (d, k) { d.classList.toggle(ACTIVE, k === i); });
      dots.style.display = n > 1 ? '' : 'none';
    }
    var thumbs = root.querySelectorAll('[data-sl-thumb]');
    [].forEach.call(thumbs, function (t, k) { t.classList.toggle(ACTIVE, k === i); });
  }
  function initSlider(root) {
    if (root.__slInit) { syncSlider(root); return; }
    root.__slInit = true;
    var track = root.querySelector('[data-sl-track]');
    if (!track) return;
    track.addEventListener('scroll', function () { syncSlider(root); }, { passive: true });
    var down = false, x0 = 0, s0 = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.target.closest('a,button')) return;
      down = true; moved = false; x0 = e.clientX; s0 = track.scrollLeft;
      track.style.scrollSnapType = 'none';
    });
    window.addEventListener('pointerup', function () {
      if (!down) return; down = false; track.style.scrollSnapType = '';
      if (moved) go(track, Math.round(track.scrollLeft / (step(track) || 1)) * step(track));
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return; moved = true; e.preventDefault(); track.scrollLeft = s0 - (e.clientX - x0);
    });
    syncSlider(root);
  }

  /* ---------- hero review rotator ---------- */
  function showReview(root, i) {
    var items = root.querySelectorAll('[data-sl-review]');
    if (!items.length) return;
    i = (i + items.length) % items.length;
    [].forEach.call(items, function (r, k) { r.hidden = k !== i; });
    [].forEach.call(root.querySelectorAll('[data-sl-rdot]'), function (d, k) { d.classList.toggle(ACTIVE, k === i); });
    root.__slIdx = i;
  }
  function initReviews(root) {
    if (root.__slInit) return;
    root.__slInit = true;
    showReview(root, 0);
    var n = root.querySelectorAll('[data-sl-review]').length;
    if (n > 1) root.__slTimer = setInterval(function () {
      if (!document.body.contains(root)) return clearInterval(root.__slTimer);
      showReview(root, (root.__slIdx || 0) + 1);
    }, 6000);
  }

  /* ---------- timeline progress (blue dot travels down the spine) ---------- */
  function initTimeline(tl) {
    if (tl.__slInit) return;
    tl.__slInit = true;
    var MOVE = 900, HOLD = 520, EASE = 'cubic-bezier(.65,0,.35,1)';
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var marks = [].slice.call(tl.querySelectorAll('[data-sl-mark]'));
    if (!marks.length) return;
    marks.forEach(function (m) { m.classList.remove('is-done', 'is-last'); m.classList.add('is-idle'); });
    var line = document.createElement('span'); line.className = 'sl-tl__prog';
    var dot = document.createElement('span'); dot.className = 'sl-tl__dot';
    tl.appendChild(line); tl.appendChild(dot);
    var started = false, step = 0;
    function pt(m) {
      var r = m.getBoundingClientRect(), t = tl.getBoundingClientRect();
      return { x: r.left - t.left + r.width / 2, y: r.top - t.top + r.height / 2 };
    }
    function place(i, anim) {
      var a = pt(marks[0]), b = pt(marks[i]);
      dot.style.transition = anim ? 'transform ' + MOVE + 'ms ' + EASE : 'none';
      line.style.transition = anim ? 'height ' + MOVE + 'ms ' + EASE : 'none';
      dot.style.transform = 'translate(' + b.x + 'px,' + b.y + 'px)';
      line.style.left = (a.x - 1) + 'px'; line.style.top = a.y + 'px'; line.style.height = (b.y - a.y) + 'px';
    }
    function arrive(i) {
      var m = marks[i]; m.classList.remove('is-idle'); m.classList.add('is-done');
      if (i === marks.length - 1) { m.classList.add('is-last'); dot.style.opacity = '0'; return; }
      setTimeout(function () { step = i + 1; place(step, true); setTimeout(function () { arrive(step); }, MOVE); }, HOLD);
    }
    function run() {
      if (started) return; started = true;
      if (reduce) {
        marks.forEach(function (m) { m.classList.remove('is-idle'); m.classList.add('is-done'); });
        step = marks.length - 1; place(step, false); dot.style.opacity = '0'; return;
      }
      place(0, false); requestAnimationFrame(function () { arrive(0); });
    }
    place(0, false);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { run(); io.disconnect(); } });
      }, { threshold: 0.25 });
      io.observe(tl);
    } else run();
    window.addEventListener('resize', function () { place(step, false); });
  }

  function initAll(scope) {
    scope = scope || document;
    [].forEach.call(scope.querySelectorAll('[data-sl-slider]'), initSlider);
    [].forEach.call(scope.querySelectorAll('[data-sl-reviews]'), initReviews);
    [].forEach.call(scope.querySelectorAll('[data-sl-timeline]'), initTimeline);
  }

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    var nav = t.closest('[data-sl-prev],[data-sl-next]');
    if (nav) {
      var root = nav.closest('[data-sl-slider]'), track = root && root.querySelector('[data-sl-track]');
      if (track) go(track, track.scrollLeft + (nav.hasAttribute('data-sl-next') ? 1 : -1) * step(track));
      return;
    }
    var dot = t.closest('[data-sl-dot]');
    if (dot) {
      var r2 = dot.closest('[data-sl-slider]'), tr2 = r2 && r2.querySelector('[data-sl-track]');
      if (tr2) go(tr2, +dot.getAttribute('data-sl-dot') * step(tr2));
      return;
    }
    var thumb = t.closest('[data-sl-thumb]');
    if (thumb) {
      var r3 = thumb.closest('[data-sl-slider]'), tr3 = r3 && r3.querySelector('[data-sl-track]');
      if (tr3) go(tr3, +thumb.getAttribute('data-sl-thumb') * step(tr3));
      return;
    }
    var rdot = t.closest('[data-sl-rdot]');
    if (rdot) { showReview(rdot.closest('[data-sl-reviews]'), +rdot.getAttribute('data-sl-rdot')); return; }

    var q = t.closest('[data-sl-faq]');
    if (q) {
      var item = q.closest('.sl-fq__item'), open = !item.classList.contains('is-open');
      item.classList.toggle('is-open', open); q.setAttribute('aria-expanded', String(open));
      return;
    }
    var ck = t.closest('[data-sl-check]');
    if (ck) { var on = !ck.classList.contains('is-on'); ck.classList.toggle('is-on', on); ck.setAttribute('aria-pressed', String(on)); return; }

    var a = t.closest('a[href]');
    if (a) {
      var href = a.getAttribute('href') || '';
      var hash = href.charAt(0) === '#' ? href.slice(1) : '';
      if (hash) {
        var target = document.getElementById(hash);
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      }
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  window.addEventListener('load', function () { initAll(); });
  window.addEventListener('resize', function () { [].forEach.call(document.querySelectorAll('[data-sl-slider]'), syncSlider); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
